<template>
  <div class="text-center">
    <div class="styleMenuv" v-for="(option, index) in options" v-bind:key="index">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small link class="ma-2" dark v-bind="attrs" v-on="on" @click="redirect(option.href, option.items.length == 0)">
            <i v-if="option.icon" v-bind:class="option.icon"></i>
            {{ $tc(option.lang) }}
          </v-btn>
        </template>
        <v-list v-if="option.items.length > 0">
          <v-list-item
            v-for="(item, index) in option.items"
            v-bind:key="index"
            @click="redirect(item.href,true)"
          >
            <v-list-item-title>{{ $tc(item.lang) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    
  </div>
</template>

<script>

export default {
  computed: {
    options: function () {
      const options = [
        {
          icon: "far fa-tachometer",
          lang: "top-menu.all.dashboard",
          name: null,
          href: "/admin/promoterDashboard",
          items: []
        },
        {
          icon: "far fa-dollar-sign",
          lang: "top-menu.eventsDetails.pricing",
          href: `/promoter/#/events/event-details/pricing/${this.$route.params.id}`,
          name: null,
          items: []
        },
        {
          icon: "far fa-clipboard",
          lang: "top-menu.eventsDetails.registrations",
          name: null,
          items: [
            {
              lang: "top-menu.registration.registration.registrant",
              href: `/admin/eventRegistrations?eventId=${this.$route.params.id}`,
              name: null
            },
            {
              lang: "top-menu.registration.registration.registered-spectator",
              href: `/promoter/#/events/${this.$route.params.id}/registeredSpectators`,
              name: 'RegisteredSpectator'
            }
          ],
        },        
        {
          icon: "far fa-clock",
          lang: "top-menu.eventsDetails.waitList",
          href: `/admin/waitList?eventId=${this.$route.params.id}`,
          name: null,
          items: []
        },
        {
          icon: "far fa-tags",
          lang: "top-menu.eventsDetails.classes",
          name: null,
          items: [
            {
              lang: "top-menu.eventsDetails.classes",
              href: `/admin/eventClasses?eventId=${this.$route.params.id}`,
              name: null
            },
            {
              lang: "top-menu.eventsDetails.division",
              href: `/promoter/#/events/event-details/divisions/${this.$route.params.id}`,
              name: 'RegisteredSpectator'
            }
          ],
        },
        {
          icon: "fab fa-delicious",
          lang: "top-menu.eventsDetails.brands",
          href: `${process.env.VUE_APP_ROOT}/admin/eventBrands?eventId=${this.$route.params.id}`,
          name: null,
          items: [],
        },
        {
          icon: "far fa-users",
          lang: "top-menu.eventsDetails.teams",
          href: `/admin/scoringGroup?eventId=${this.$route.params.id}`,
          name: null,
          items: [],
        },
        {
          icon: "far fa-flag-checkered",
          lang: "top-menu.eventsDetails.startGrids",
          href: `/admin/startGrids?eventId=${this.$route.params.id}`,
          name: null,
          items: [],
        },
        {
          icon: "far fa-copy ",
          lang: "top-menu.eventsDetails.clone_events",
         href: `/promoter/#/events/cloneEvents`,
          name: null,
          items: [],
        },
        {
          icon: "fas fa-arrow-left",
          lang: "top-menu.eventsDetails.back_button",
          href: `/admin/eventDetails?eventId=${this.$route.params.id}`,
          name: null,
          items: [],
        }
      ];
      this.generateTopMenu(options);
      return options;
    }
  },
  methods: {    
    generateTopMenu: function (items) {
      let options = [];
      options = items.map((elem) => {
        const subitems = elem.items.map((elem1) => {
          return {
            ...elem1,
            text: this.$t(elem1.lang)
          };
        });
        return {
          ...elem,
          text: this.$t(elem.lang),
          items: subitems
        };
      });
      this.$emit("loadTopMenuResponsive", options);
    },
    redirect(url, band) {
      if(band)
        window.location.href = url;
    }
  }
};
</script>

<style scoped>
.legacy-dashboard {
  text-align: right !important;
  text-align: -moz-right !important;
  text-decoration: underline !important;
  color: #0e152d !important;
  margin-right: 10px;
}
.styleMenuv {
  display: inline;
}
</style>
